import wx from '@/resource/js/wexinJsApi'
import {invokeApi} from '@/resource/js/GLOBAL2'
import {GetQueryString,getCookie} from '@/resource/js/common';


const pathPub = '/pages/active'
const shareParam = {
    bindCode:GetQueryString('bindCode')||GetQueryString('bindcode'),
    productId:GetQueryString('proid'),
    ncp_bat:GetQueryString('ncp_bat'),
    adCookie:getCookie('lechunccadcookieline')||'',
    gdt_vid:GetQueryString('gdt_vid')||'',
    dataSource:GetQueryString('dataSource')||'',
    itemType:GetQueryString('itemType')||'',
    itemId:GetQueryString('itemId')||'',
    groupType:window.location.pathname.indexOf('promotion_detail.html')>-1?1:(window.location.pathname.indexOf('sku_detail.html')>-1?4:'')
}
const getWxShareInfo=(state,url,callback)=>{//state=1:特殊处理的拼接url;state=2:res.url
    return new Promise((resolve,reject) => {
        wx.ready(function() {
            invokeApi('fit/getShare', shareParam, 'get', Math.random(), function (res) {
                let returnUrl = '';
                if(state==1){
                    returnUrl = `${url}&ncp_bat=${res.ncp_bat}`
                }else{
                    returnUrl = res.url?res.url:resetUrl(window.location.href,res.ncp_bat)
                }
                wx.wxShare(res.title,returnUrl,res.digest,res.imageUrl,function(res1){
                    console.log('分享成功',res1,res)
                    callback(res)
                    resolve(res);
                },function(err){
                    reject(err)
                })
            })
        })


    })
}
function resetUrl(url,code){
    return url.indexOf('ncp_bat')>-1?url:(url.indexOf('?')>-1?`${url}&ncp_bat=${code}`:`${url}?ncp_bat=${code}`)
}
if(window.location.pathname==`${pathPub}/five_active/invite/invite.html`
    ||window.location.pathname==`${pathPub}/group/cantuan/cantuan.html`
    ||window.location.pathname==`${pathPub}/group/group_index/group_index.html`
    ||window.location.pathname==`${pathPub}/group/open_succ/open_succ.html`
    ||window.location.pathname==`${pathPub}/red_packet/red_result.html`
    ||window.location.pathname==`${pathPub}/miaosha/miaosha.html`
    ||window.location.pathname==`${pathPub}/activeCoupon/activeCoupon.html`
    ||window.location.pathname==`${pathPub}/red_packet/red_index.html`){

}else{
    getWxShareInfo()
}
export {getWxShareInfo}



// WEBPACK FOOTER //
// ./src/resource/js/share_global.js